import { firmwareDownload } from "../../actions/stat";

import styles from "../../styles/firmware/list.module.css";

export default function NewFirmwareButton({
  link = "",
  statistic = "",
  text = "",
}) {
  return (
    <a
      href={link}
      className={styles.button}
      onClick={() => firmwareDownload(statistic)}
    >
      <p>{text}</p>
    </a>
  );
}
